export enum InputTypes {
  'search' = 'search',
  'number' = 'number',
  'password' = 'password',
  'text' = 'text',
}
